document.addEventListener('DOMContentLoaded', function() {   
  var $slickImg = $(".carousel");
  var mq = window.matchMedia('');
 
  function initSlick() {
    if (!$slickImg.hasClass('slick-initialized')) {
      $slickImg.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 6000,
        dots: true
      });
    }
  }
 
  function slickHandler(e) {
    if (e.matches) {
      initSlick(); // mobile
    } else {
      if ($slickImg.hasClass('slick-initialized')) {
        $slickImg.slick('unslick'); // desktop
      }
    }
  }

  slickHandler(mq);
  mq.addEventListener('change', slickHandler);
});